import { cn } from "../../lib/cn";

export function Spinner({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "h-8 w-8 animate-spin rounded-full border-2 border-brand-200 border-t-brand-700",
        className
      )}
      role="status"
      aria-label="Loading"
    />
  );
}

export function LoadingOverlay({ show }: { show: boolean }) {
  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-content-primary/20 backdrop-blur-[1px]"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="rounded-xl border border-brand-100 bg-surface p-6 shadow-elevated">
        <Spinner className="border-brand-200 border-t-brand-600" />
      </div>
    </div>
  );
}

export function EmptyState({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-surface-muted px-6 py-12 text-center">
      <p className="text-sm font-medium text-content-primary">{title}</p>
      {description && (
        <p className="mt-1 max-w-sm text-sm text-content-muted">{description}</p>
      )}
    </div>
  );
}

export function PageSection({
  title,
  description,
  children,
  className,
}: {
  title?: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <section className={cn("space-y-4", className)}>
      {(title || description) && (
        <header className="space-y-1">
          {title && (
            <h2 className="text-sm font-semibold uppercase tracking-wide text-content-muted">
              {title}
            </h2>
          )}
          {description && (
            <p className="text-sm text-content-secondary">{description}</p>
          )}
        </header>
      )}
      {children}
    </section>
  );
}
